import { useRootLoadersStore } from "./root-loaders.store";

export const useRootLoader = (loaderId: string) => {
  const getRootLoader = useRootLoadersStore((state) => state.getRootLoader);
  const incrementPending = useRootLoadersStore(
    (state) => state.incrementPending
  );
  const decrementPending = useRootLoadersStore(
    (state) => state.decrementPending
  );

  const rootLoader = getRootLoader(loaderId);
  const idle = rootLoader.pendingCounter === 0;
  const pending = rootLoader.pendingCounter > 0;

  const toIdle = () => decrementPending(loaderId);
  const toPending = () => incrementPending(loaderId);

  return { idle, pending, toIdle, toPending };
};
